import {
  ItineraryActivity,
  AccommodationActivity,
  ActivityActivity,
  EventsActivity,
  FoodDrinksActivity,
  FlightActivity,
  TransportationActivity,
} from '../models/activity.model';

/**
 * Extract time from activity for sorting
 * Returns a sortable time string (HH:mm format or default)
 */
export const getActivityTime = (activity: ItineraryActivity): string => {
  switch (activity.type) {
    case 'accommodation': {
      const accommodationActivity = activity as AccommodationActivity;
      return accommodationActivity.inOrOutActivity === 'out'
        ? accommodationActivity.check_out_time || '23:59'
        : accommodationActivity.check_in_time || '00:00';
    }
    case 'activity':
    case 'events':
      return (activity as ActivityActivity | EventsActivity).start_time || '23:59';
    case 'food-drinks':
      return (activity as FoodDrinksActivity).start_time || '23:59';
    case 'flight':
      const flightActivity = activity as FlightActivity;
      return flightActivity.travels?.[0]?.fromTime || '23:59';
    case 'transportation':
      const transportActivity = activity as TransportationActivity;
      return transportActivity.travels?.[0]?.time || '23:59';
    case 'notes':
      return '23:59'; // Notes always at the end
    default:
      return '23:59';
  }
};

/**
 * Sort activities by time
 */
export const getSortedActivities = (
  activities: ItineraryActivity[],
  shouldSort: boolean
): ItineraryActivity[] => {
  if (!shouldSort) return activities;
  
  return [...activities].sort((a, b) => {
    const timeA = getActivityTime(a);
    const timeB = getActivityTime(b);
    return timeA.localeCompare(timeB);
  });
};
